import React from 'react'
import Image from "next/image";
import Head from "next/head";
import styles from "../about-upsc/about-upsc.module.css";
import book from "../../assets/images/about/book.svg";
import Link from 'next/link';


const About_Civil_Service = () => {

    const imglist =[
        {Image: book,cont:"Indian Polity",cont1:"Lakshmikanth",cont2:"Indian Polity book by Shankar IAS Academy"},
        {Image: book,cont:"Indian History",cont1:"Standard 11th and 12th Standard NCERT old edition"},
        {Image: book,cont:"India’s struggle for Independence",cont1:'Spectrum’s "A brief history of Modern India" '},
        {Image: book,cont:"Geography",cont1:"Standard 6th to 12th NCERT",cont2:"Certificate Physical and Human Geography by Goh Cheng Leong, Oxford Student Atlas."},
        {Image: book,cont:"Indian Economy",cont1:"Indian Economy & General Economics book by Shankar IAS Academy",cont2:"Economic Survey"},
        {Image: book,cont:"General Science",cont1:"Standard 9th and 10th Old NCERT",cont2:"Class Notes"},
        {Image: book,cont:"Environment",cont1:"Environment Book by Shankar IAS Academy"},
        {Image: book,cont:"India Year Book",cont1:"Publication Division, Government of India"},
        {Image: book,cont:"Indian Art and Culture",cont1:"NCERT Books",cont2:"Art and Culture book by Shankar IAS Academy"},
        {Image: book,cont:"Current Affairs",cont3:"Refer",url:"https://www.iasparliament.com/",link:"www.iasparliament.com &",url1:"https://www.iasparliament.com/UPSC-IAS-daily-current-videos",cont4:"Civilspedia - Current affairs digital library"},
        {Image: book,cont:"General Trends of Exams",cont1:"Shankar IAS academy’s Blog"}
      ]
    
      const imglist1 =[
        {Image: book,cont:"Ancient India / Medieval India / Art and Culture",cont1:"Old NCERT, Introduction to Fine Art NCERT Ancient & Medieval India book by Shankar IAS Academy"},
        {Image: book,cont:"India’s Struggle for Independence",cont1:"NCERT",cont2:"Spectrum’s A brief history of Modern India"},
        {Image: book,cont:"India Since Independence or India After Gandhi",cont1:"Bipin Chandra or",cont2:"Ramchandra Guha"},
        {Image: book,cont:"History of the World Contemporary World",cont1:"World History book by Shankar IAS Academy",cont2:"Old NCERT (by Arjun Dev)"},
        {Image: book,cont:"Art and Culture Fine arts",cont1:"Standard 12th NCERT"}
      ]
        
  return (
    <>
  <div className="container">
                        <div className="row">
                            <div className="col">
                               <h2 className={`${styles.sectiontitle}`}>GS Preliminary</h2>
                            </div>
                        </div>
                    </div>


                    <div className="container">
                        <div className="row">
                            {imglist.map((item,index)=>(
                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12" key={index}>
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={item.Image} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; {item.cont}</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>{item.cont1}</p>
                                        <p className={`${styles.acheiverrank}`}>{item.cont2}</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>{item.cont3} <a href={item.url} target="_blank" rel="noreferrer"><u>{item.link}</u></a></p>
                                        <p className={`${styles.acheiverrank}`}><a href={item.url1} target="_blank" rel="noreferrer"><u>{item.cont4}</u></a></p>
                                    </div>   
                                </div>
                            ))}
                        </div>
                    </div>


                    <div className="container">
                        <div className="row">
                            <div className="col">
                            <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                        <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                            <div className="d-inline">
                                                <p className={`${styles.ullispan} d-inline`}>
                                                The respective NCERT Textbooks have to be mandatory studied.
                                                </p>
                                            </div>
                                        </li>

                                        <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                            <div className="d-inline">
                                                <p className={`${styles.ullispan} d-inline`}>
                                                The Corresponding Ministry websites should also be referred to for latest policy updates.
                                                </p>
                                            </div>
                                        </li>

                                        <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                            <div className="d-inline">
                                                <p className={`${styles.ullispan} d-inline`}>
                                                For current events read a Daily Newspaper (preferably The Hindu).
                                                </p>
                                            </div>
                                        </li>


                            </ul>
                            
                            </div>
                        </div>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col">
                               <h2 className={`${styles.sectiontitle} mb-0`}>GS Mains Examination</h2>
                               <p className={`${styles.aboutheading1} pt-md-2 mb-0`}>Paper I</p>
                               <p className={`${styles.aboutheading1} pt-md-2`}>HISTORY AND CULTURE</p>
                            </div>
                        </div>
                    </div>


                    <div className="container">
                        <div className="row">

                            {imglist1.map((item,index)=>(
                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12" key={index}>
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={item.Image} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; {item.cont}</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>{item.cont1}</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>{item.cont2}</p>
                                    </div>   
                                </div>
                            ))}



                                <p className={`${styles.aboutheading1}`}>SOCIETY IN INDIA</p>
                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Indian Society</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Standard 12th NCERT</p>
                                    </div>   
                                </div>

                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Social Change and Development in India</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Standard 12th NCERT</p>
                                    </div>   
                                </div>

                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Indian Society</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>S.C.Dube / Relevant GOI Website</p>
                                    </div>   
                                </div>


                                <p className={`${styles.aboutheading1}`}>GEOGRAPHY</p>
                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Standard 11th & 12th NCERT</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>NCERT</p>
                                        <p className={`${styles.acheiverrank}`}>Class Notes</p>
                                    </div>   
                                </div>



                                <p className={`${styles.aboutheading1} mb-0`}>Paper II</p>
                                <p className={`${styles.aboutheading1} pt-md-2`}>INDIAN POLITY</p>
                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Indian Constitution at Work</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Indian Polity by Shankar IAS Academy</p>
                                    </div>   
                                </div>


                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Indian Polity</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>IAS Parliament Material</p>
                                    </div>   
                                </div>



                                <p className={`${styles.aboutheading1}`}>GOVERNANCE</p>
                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; From Government to Governance</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Kuldeep Mathur</p>
                                    </div>   
                                </div>


                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; 2nd ARC Report</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Published by Government of India</p>
                                    </div>   
                                </div>


                                <p className={`${styles.aboutheading1}`}>INTERNATIONAL RELATIONS</p>
                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; SIA Material</p>
                                        <p className={`${styles.acheiverrank} mb-0`}><Link href="http://www.iasparliament.com/downloads/mainstorming-2019/bilateral-relations-i-392" target="_blank" rel="noreferrer"><u>http://www.iasparliament.com/</u></Link></p>
                                    </div>   
                                </div>


                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Newspaper</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>The Hindu</p>
                                    </div>   
                                </div>



                                <p className={`${styles.aboutheading1} mb-0`}>Paper III</p>
                                <p className={`${styles.aboutheading1} pt-md-2`}>ECONOMY</p>
                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Economic Survey</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Government of India</p>
                                    </div>   
                                </div>


                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Business Line - Newspaper (Editorial)</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>The Hindu group.</p>
                                    </div>   
                                </div>

                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Indian Economy Since Independence</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Uma Kapila</p>
                                    </div>   
                                </div>


                                <p className={`${styles.aboutheading1}`}>INDIAN AGRICULTURE</p>
                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Agriculture Topics</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Agriculture Book by Shankar IAS Academy</p>
                                    </div>   
                                </div>


                                <p className={`${styles.aboutheading1}`}>SCIENCE AND TECHNOLOGY</p>
                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Newspaper</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>The Hindu</p>
                                    </div>   
                                </div>

                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Science and Technology</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Science and Technology Book by IAS academy</p>
                                        <p className={`${styles.acheiverrank}`}>Class Notes</p>
                                    </div>   
                                </div>


                                <p className={`${styles.aboutheading1}`}>ENVIRONMENT</p>
                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Newspaper</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>The Hindu</p>
                                        <p className={`${styles.acheiverrank}`}>Environment Book by Shankar IAS Academy</p>
                                    </div>   
                                </div>


                                <p className={`${styles.aboutheading1}`}>INTERNAL SECURITY ISSUES</p>
                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Internal Security</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Internal Security Book by Shankar IAS Academy</p>
                                        <p className={`${styles.acheiverrank}`}>News Paper Notes</p>
                                    </div>   
                                </div>


                                <p className={`${styles.aboutheading1}`}>Paper IV</p>
                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; 2nd ARC Reports</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Government of India</p>
                                    </div>   
                                </div>

                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; From Government to Governance</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Kuldeep Mathur</p>
                                    </div>   
                                </div>

                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Shankar IAS Academy Book and Class Notes</p>
                                        <p className={`${styles.acheiverrank} mb-0`}></p>
                                    </div>   
                                </div>


                                <p className={`${styles.aboutheading1}`}>FOR REFERENCE PURPOSE ONLY</p>
                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Competitive Exams - A Success Guide</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>V Palanichamy IIS</p>
                                    </div>   
                                </div>

                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; Civil Services Exam - A Complete Guide</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>V Palanichamy IIS</p>
                                    </div>   
                                </div>

                                <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading2} mb-0`}><Image src={book} className="img-fluid" alt="Upsc notes" title="Upsc notes"/>&nbsp; At the Service of a Billion Plus</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Shankar Ganesh Karuppiah</p>
                                    </div>   
                                </div>


                        </div>
                    </div>
</>
  )
}

export default About_Civil_Service;